/**
 * AssignmentsService — cliente frontend de /teacher/assignments y
 * /progress/my-assignments. Wrappeá las llamadas autenticadas para que las UI
 * no tengan que lidiar con URLs ni tipos HTTP.
 */

import { authService } from '../auth/AuthService';

export type AssignmentStatus = 'pending' | 'done' | 'overdue';

export interface Assignment {
  id: number;
  teacher_id: number;
  student_id: number;
  /** Nombre del profesor o del alumno según el contexto de la consulta. */
  student_name: string | null;
  case_slug: string;
  assigned_at: string;
  due_at: string | null;
  completed_at: string | null;
  last_score: number | null;
  status: AssignmentStatus;
  note: string | null;
}

export interface CreateAssignmentInput {
  student_ids: number[];
  case_slug: string;
  due_at?: string;
  note?: string;
}

class AssignmentsService {
  listForTeacher(): Promise<Assignment[]> {
    return authService.request<Assignment[]>('/teacher/assignments');
  }

  listForMe(): Promise<Assignment[]> {
    return authService.request<Assignment[]>('/progress/my-assignments');
  }

  create(input: CreateAssignmentInput): Promise<Assignment[]> {
    return authService.request<Assignment[]>('/teacher/assignments', {
      method: 'POST',
      body: JSON.stringify(input),
    });
  }

  delete(id: number): Promise<void> {
    return authService.request<void>(`/teacher/assignments/${id}`, {
      method: 'DELETE',
    });
  }

  markDone(id: number, score: number): Promise<Assignment> {
    return authService.request<Assignment>(`/progress/my-assignments/${id}/done`, {
      method: 'POST',
      body: JSON.stringify({ score }),
    });
  }
}

export const assignmentsService = new AssignmentsService();
